import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import SumListField from 'portaltransparencia-common/components/SumListField.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

import DatePicker from 'portaltransparencia-common/components/DatePicker.react.js';
import { Col, Row } from 'react-bootstrap';
import FilterButtons from '../components/FilterButtons.react';
import Panel from 'portaltransparencia-common/components/Panel.react.js';

export class RepasseDetalhe extends Component {
  static propTypes = {
    filtros: PropTypes.object,
    repasses: PropTypes.object.isRequired,
    onChangeFiltro: PropTypes.func,
    onConsulta: PropTypes.func,
    onResetFiltro: PropTypes.func
  };

  renderRepasses = data => {
    const key = `${data.get('data')}_${data.get('valor')}_${data.get(
      'conta'
    )}_${data.get('idContaCorrente')}_${data.get('nroLancamento')}`;
    return (
      <tr key={key}>
        <td colSpan={2}>{DateUtils.formatDateTimeShort(data.get('data'))} </td>
        <td colSpan={9}>{data.get('local')}</td>
        <td colSpan={1} className="right">
          <NumberFormatter value={data.get('valor')} />
        </td>
      </tr>
    );
  };

  render() {
    const {
      repasses,
      filtros,
      onChangeFiltro,
      onResetFiltro,
      onConsulta
    } = this.props;

    return (
      <section>
        <Panel title="Buscar" isForm mobileClose>
          <Row>
            <Col xs={6} sm={3} md={3}>
              <DatePicker
                id="dataInicial"
                name="dataInicial"
                ref="dataInicial"
                label="Data Inicial do Lançamento"
                onChange={onChangeFiltro}
                value={filtros.get('dataInicial')}
              />
            </Col>
            <Col xs={6} sm={3} md={3}>
              <DatePicker
                id="dataFinal"
                name="dataFinal"
                ref="dataFinal"
                label="Data Final do Lançamento"
                onChange={onChangeFiltro}
                value={filtros.get('dataFinal')}
              />
            </Col>
            <Col xs={12} sm={3} md={3}>
              <FilterButtons
                idBtnReset="btnResetFilter"
                onConsulta={onConsulta}
                onReset={onResetFiltro}
              />
            </Col>
          </Row>
        </Panel>

        <div className="panel-table-outer">
          <table className="panel-table striped fancy">
            <TableHeader width="100%" empty={repasses.isEmpty()}>
              <tr>
                <th colSpan={2}>Data do Repasse</th>
                <th colSpan={9}>Banco</th>
                <th colSpan={1}>Valor</th>
              </tr>
            </TableHeader>
            <tbody>{repasses.map(this.renderRepasses)}</tbody>
            {!repasses.isEmpty() && (
              <tfoot>
                <tr>
                  <td colSpan={2}></td>
                  <td colSpan={9}></td>
                  <td colSpan={1} className="right">
                    <i>Total: </i>
                    <SumListField fieldName="valor" list={repasses} />
                  </td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </section>
    );
  }
}

export default RepasseDetalhe;
